import { useState } from 'react';
import { faqs, site } from '../../../mocks/entertainment';
import SectionHead from './SectionHead';

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="relative scroll-mt-16 bg-background-100 py-16 md:py-20">
      <div className="mx-auto grid max-w-[1240px] grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-[0.9fr_1.5fr] lg:gap-14">
        <div>
          <SectionHead eyebrow="常见问题 · FAQ" title="关于盘点的几个问题" />
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            想了解我们的更新节奏、热度口径与转载规则？下面这几条基本都能答上。没找到答案，欢迎直接写信到
            <span className="mx-1 font-semibold text-primary-700">{site.email}</span>
            。
          </p>
          <div className="mt-6 rounded-xl bg-background-50 p-5 ring-1 ring-background-200/80">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-lg text-accent-700">
                <i className="ri-mail-send-line" aria-hidden="true"></i>
              </span>
              <div>
                <p className="text-sm font-bold text-foreground-950">反馈 / 指正</p>
                <p className="text-xs text-foreground-500">核实后会加更正标注</p>
              </div>
            </div>
            <a
              href={`mailto:${site.email}`}
              className="mt-4 inline-flex w-full items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-arrow-right-line mr-2" aria-hidden="true"></i>
              给编辑部写信
            </a>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((f, i) => {
            const active = openIdx === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-xl ring-1 transition-colors ${
                  active ? 'bg-background-50 ring-primary-300' : 'bg-background-50/60 ring-background-200/80 hover:ring-background-300'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(active ? -1 : i)}
                  aria-expanded={active}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <h3 className="text-base font-bold leading-snug text-foreground-950">
                    <span className="mr-2 text-sm text-accent-600">Q{i + 1}</span>
                    {f.q}
                  </h3>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm transition-all ${
                      active ? 'rotate-45 bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'
                    }`}
                  >
                    <i className="ri-add-line" aria-hidden="true"></i>
                  </span>
                </button>
                {active && (
                  <div className="px-5 pb-5">
                    <p className="border-t border-background-100 pt-4 text-sm leading-relaxed text-foreground-600">
                      {f.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}